"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.menuItemSecondaryTextVariantColors = exports.MenuItemSecondaryTextStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
var _typography = require("../../../constants/typography");
const menuItemSecondaryTextVariantColors = (0, _sdsThemeInternal.themed)({
  metadata: (0, _designTokensReact.color)("color--text--neutral--weak"),
  hint: {
    "lodestar-light": (0, _designTokensReact.color)("color--text--neutral--weak"),
    "ursa-light": (0, _designTokensReact.color)("color--text--neutral--weaker")
  },
  disabled: {
    "lodestar-light": (0, _designTokensReact.color)("color--text--neutral--weaker"),
    "ursa-light": (0, _designTokensReact.color)("color--text--neutral--weakest")
  }
});
exports.menuItemSecondaryTextVariantColors = menuItemSecondaryTextVariantColors;
const MenuItemSecondaryTextStyled = (0, _styled.default)("span")`
    color: ${_ref => {
  let {
    themeKey,
    variant
  } = _ref;
  return menuItemSecondaryTextVariantColors[variant](themeKey);
}};
    line-height: ${_typography.body.lineHeight}px;

    button[role="menuitem"][aria-disabled] & {
        color: ${_ref2 => {
  let {
    themeKey
  } = _ref2;
  return menuItemSecondaryTextVariantColors["disabled"](themeKey);
}};
        cursor: not-allowed;
    }

    // No transition of font-weight. Always 400.
    &,
    &:focus,
    &[aria-expanded="true"] {
        font-weight: ${_typography.body.fontWeight};
    }
`;
exports.MenuItemSecondaryTextStyled = MenuItemSecondaryTextStyled;
//# sourceMappingURL=MenuItemSecondaryTextStyled.js.map